import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CSV_MAPPINGS_DEFINITION_ACTION_TYPE } from '../actions';

const initialState = {};

const csvMappingsDefinitionReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case CSV_MAPPINGS_DEFINITION_ACTION_TYPE.GET_CSV_MAPPING_DEFINITION:
        return payload || state;

      case CSV_MAPPINGS_DEFINITION_ACTION_TYPE.CREATE_CSV_MAPPING_DEFINITION:
      case CSV_MAPPINGS_DEFINITION_ACTION_TYPE.EDIT_CSV_MAPPING_DEFINITION:
        draft[payload.csvMappingDefinitionId] = payload;
        break;

      case CSV_MAPPINGS_DEFINITION_ACTION_TYPE.DELETE_CSV_MAPPING_DEFINITION:
        delete draft[meta.csvMappingDefinitionId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default csvMappingsDefinitionReducer;
